/* unplugin-vue-components disabled */import { render } from "./MainHead.vue?vue&type=template&id=3dc7eb12&scoped=true"
import script from "./MainHead.vue?vue&type=script&lang=js"
export * from "./MainHead.vue?vue&type=script&lang=js"

import "./MainHead.vue?vue&type=style&index=0&id=3dc7eb12&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-digital-read\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc7eb12"]])

export default __exports__